module.exports = __webpack_public_path__ + "static/media/bigway.214c02ce.mp4";